import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom';

import 'src/polyfills/polyfill';
import 'src/version.txt';
import { App } from 'src/App';

const rootElement = document.getElementById('app') || document.body;
ReactDOM.render(<App />, rootElement);

// eslint-disable-next-line import/no-default-export
export default App;
